/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Minrequired5Inputs */

const en_coinvestments_gpestimatedticketsize_modal_minrequired5 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Minrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum ticket size is required`)
};

/**
* | output |
* | --- |
* | "Minimum ticket size is required" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Minrequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_minrequired5 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Minrequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Minrequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_minrequired5(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_minrequired5 as "coInvestments_gpEstimatedTicketSize_modal_minRequired" }